import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const ALL_GRADES = [
  { label: 'Staff', value: 'STAFF' },
  { label: 'Preschool', value: 'PS' },
  { label: 'Transitional Kindergarten', value: 'TK' },
  { label: 'Kindergarten', value: '0' },
  { label: 'First Grade', value: '1' },
  { label: 'Second Grade', value: '2' },
  { label: 'Third Grade', value: '3' },
  { label: 'Fourth Grade', value: '4' },
  { label: 'Fifth Grade', value: '5' },
  { label: 'Sixth Grade', value: '6' },
  { label: 'Seventh Grade', value: '7' },
  { label: 'Eighth Grade', value: '8' },
  { label: 'Freshman', value: '9' },
  { label: 'Sophomore', value: '10' },
  { label: 'Junior', value: '11' },
  { label: 'Senior', value: '12' },
  { label: 'Other', value: null },
];

const GradeInput = ({
  val = '', onChange, required = false, availableGrades = [],
}) => {
  const gradeOptions = availableGrades.length > 0
    ? ALL_GRADES.filter((grade) => availableGrades.includes(grade.value))
    : ALL_GRADES;

  return (
    <Select
      value={ALL_GRADES.find((grade) => grade.value === val)}
      options={gradeOptions}
      onChange={(opt) => onChange(opt.value)}
    />
  );
};

GradeInput.propTypes = {
  val: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  availableGrades: PropTypes.arrayOf(PropTypes.string),
};

export default GradeInput;
